/**
 *  SessionStorage abstraction to deal with Safari in incognito mode.
 *  This object is accesible globally on window object as SessionStorage
 *
 *  ```
 *  window.SessionStorage.getItem('storage-key')
 *  ```
 */
class SessionStorage {
  /* eslint require-jsdoc: 0 */
  constructor() {
    this.storage = {}
    this.sessionStorage = null

    if (sessionStorage) {
      this.sessionStorage = sessionStorage
    }
  }

  /**
   *  Clear all keys in storage
   */
  clear() {
    if (!this.sessionStorage) {
      return (this.storage = {})
    }

    this.sessionStorage.clear()
  }

  /**
   *  Get one item in the storage by key. Returns undefinded if key is not
   *  present.
   *  @param   {string}  key  The item key.
   */
  getItem(key) {
    if (!this.sessionStorage) {
      return JSON.parse(this.storage[key])
    }

    return JSON.parse(this.sessionStorage.getItem(key))
  }

  /**
   *  Set one item inside storage by key.
   *  @param  {string}  key    The item key.
   *  @param  {any}     value  The item itself. Notice that the value will be
   *                           stringified and stored as string.
   */
  setItem(key, value) {
    if (!this.sessionStorage) {
      return (this.storage[key] = JSON.stringify(value))
    }

    return this.sessionStorage.setItem(key, JSON.stringify(value))
  }
}

/**
 *  Session storage monkey patch
 */
export function initSessionStorage() {
  window.SessionStorage = new SessionStorage()
}
